import PropTypes from 'prop-types';
import React from 'react';
import ApplePay from '../containers/ApplePay';

const WaitingListApplePay = ({ onClick }) => (
  <div className="u-text-center u-pt">
    <ApplePay
      className="u-1/1 u-1/2-medium-and-up"
      onClick={onClick}
    />
  </div>
);
WaitingListApplePay.propTypes = {
  onClick: PropTypes.func,
};
WaitingListApplePay.defaultProps = {
  onClick: null,
};

export default WaitingListApplePay;




// WEBPACK FOOTER //
// ./src/app/reservation/components/WaitingListApplePay.jsx